import React, { useState, useEffect, useContext } from "react";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import { getAllTestimonials } from "../services/testimonialServices";
import { LanguageContext } from "../contexts/LanguageContext";
import { useTranslation } from "react-i18next";
import DOMPurify from "dompurify";

const TestimonialsSection = () => {
  const [testimonials, setTestimonials] = useState([]);
  const { language } = useContext(LanguageContext);
  const { t } = useTranslation();

  const getLocalizedKey = (key) => `${key}_${language.toLowerCase()}`;

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await getAllTestimonials();
        const activeTestimonials = response.filter((t) => t.is_active);
        setTestimonials(activeTestimonials);
      } catch (error) {
        console.error("Erreur lors de la récupération des témoignages :", error);
      }
    };

    fetchTestimonials();
  }, []);

  if (testimonials.length === 0) {
    return (
      <p className="text-center text-gray-600 dark:text-gray-300">
        Aucun témoignage disponible pour le moment.
      </p>
    );
  }

  return (
    <div className="py-12">
      <div className="container mx-auto px-4 max-w-7xl">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8">
          {t("testimonials.title")}
        </h2>
        <p className="text-center text-gray-600 dark:text-gray-300 mb-12">
          {t("testimonials.subtitle")}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg shadow p-6 relative"
            >
              <p className="text-sm text-gray-500 dark:text-gray-200 mb-3">
                {new Date(testimonial.testimonial_date).toLocaleDateString()}
              </p>
              <h4 className="text-lg font-semibold text-primary mb-4 font-satoshi">
                {testimonial[getLocalizedKey("testimonial_title")] || "Fonction non précisée"}
              </h4>

              <div className="relative px-5 py-4 bg-[#E8BB89] bg-opacity-50 dark:bg-gray-800 rounded">
                <FaQuoteLeft className="absolute -top-2 -left-2 text-xl text-[#E8BB89] dark:text-gray-200" />
                <div
                  className="text-gray-700 dark:text-gray-200 text-sm"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      testimonial[getLocalizedKey("testimonial_content")] ||
                        "<p>Contenu indisponible</p>"
                    ),
                  }}
                ></div>
                <FaQuoteRight className="absolute -bottom-2 -right-2 text-xl text-[#E8BB89] dark:text-gray-200" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialsSection;
